import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Flexer, Icon } from '@ontruck/orc';

import { compose } from 'recompose';

import { CopyableText } from 'modules/Common/Copy';

const enhance = compose(injectIntl);

const IdCell = React.memo(
  ({ id, idType = 'journey', intl, isRecurring, copiable, color = 'grey500', onClick }) => {
    const prefixes = intl.messages.prefixes;
    const idWithPrefix = `${prefixes[`${idType}_id`]}${id}`;
    return (
      <Flexer.Parent>
        <Flexer.Parent alignItems="center">
          {(copiable && <CopyableText text={idWithPrefix} onClick={onClick} />) || idWithPrefix}
        </Flexer.Parent>
        <Flexer.Parent flexDirection="column" alignItems="center">
          {isRecurring && idType === 'shipperorder' && (
            <Icon glyph="repeat" size="1.35rem" color={color} />
          )}
        </Flexer.Parent>
      </Flexer.Parent>
    );
  }
);

IdCell.propTypes = {
  id: PropTypes.number.isRequired,
  idType: PropTypes.string.isRequired,
  intl: PropTypes.any.isRequired,
  isRecurring: PropTypes.bool,
  copiable: PropTypes.bool,
};

IdCell.defaultProps = {
  isRecurring: false,
};

export default enhance(IdCell);
